import { notification } from 'antd'
import apiClient from 'services/axios'

export const getAttendanceIssue = async ({
  skip,
  limit,
  searchedEmployee,
  year,
  month,
  depId,
  userProcess,
}) => {
  try {
    return await apiClient.get('/attendance-issue', {
      params: {
        skip,
        limit,
        searchedEmployee,
        year,
        month,
        depId,
        userProcess,
      },
    })
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.error || 'Something went wrong',
      })
    }
  }
  return null
}
